import {
  BUS_LOCATION_CACHED_TIME_MILLIS,
  LAST_STOP_ARRIVAL_TIME_THRESHOLD_MIN,
} from "@/types";

import { createBusLocationUpdatedTimeManager } from "@/utils/busLocationFetchControl";

import { computed } from "vue";

import { useServiceStore } from "@/stores/serviceStore";
import useGetAccessToken from "@/use/useGetAccessToken";

/** 실시간 버스 위치 API 호출 여부를 결정하는 설정 값을 관리 */
export const useBusLocationFetchConfig = () => {
  const serviceStore = useServiceStore();

  const isLoggedIn = computed(() => !!useGetAccessToken());

  const { updateBusLocationUpdatedAt, isLocationCacheExpired } =
    createBusLocationUpdatedTimeManager(BUS_LOCATION_CACHED_TIME_MILLIS);

  const lastBusStopArrivalThresholdMin = computed(
    () =>
      serviceStore.serviceInfo?.lastBusStopArrivalThresholdMin ??
      LAST_STOP_ARRIVAL_TIME_THRESHOLD_MIN
  );

  return {
    isLoggedIn,
    isLocationCacheExpired,
    lastBusStopArrivalThresholdMin,
    updateBusLocationUpdatedAt,
  };
};
